const toLocation = location => {
	if (location && location.query && location.query.from) {
		return location.query.from;
	}
	if (location && location.state && location.state.from) {
		return location.state.from;
	}

	return undefined;
};

export default toLocation;
